import React from "react";
import { BasicIndicator } from "../../../../components/BasicIndicator/BasicIndicator";
import "./MyTasksCard.scss";
const MyTasksCard = (props: any) => {
  const { title, data } = props;
  return (
    <div className="my-tasks-card-container">
      <h2 className="card-title">{title}</h2>
      <div>
        <div>
          <BasicIndicator
            color={"#4d6572"}
            value={data?.pendingTasksCount | 0}
            label={"Tareas pendientes"}
            size="sm"
          />
        </div>

        <div>
          <BasicIndicator
            color={"#ed3b4b"}
            value={data?.overdueTasksCount | 0}
            label={"Tareas vencidas"}
            size="sm"
          />
        </div>
      </div>
    </div>
  );
};

export { MyTasksCard };
